import {ArrUtil} from 'yougile-util'
import {Hub} from 'yougile-model'

export const squashExcessMirrors = (tasks: Hub[] = []): void => {
  const toDelete: Hub[] = []
  const taskIx = new Map(tasks.map(h => [h.id, h]))

  for (const hub of tasks) {
    if (!hub.data.mirrors) {
      continue
    }
    const presentMirrors = ArrUtil.defined(
      hub.data.mirrors.filter(id => taskIx.has(id)).map(id => taskIx.get(id))
    )
    const sorted = presentMirrors.sort((a, b) => a.timestamp - b.timestamp)
    const oldest = sorted[0]
    if (oldest && hub.id !== oldest.id) {
      toDelete.push(hub)
    }
  }

  for (const del of toDelete) {
    const idx = tasks.indexOf(del)
    tasks.splice(idx, 1)
  }
}
